export const MAX_EVENT_NAME_LENGTH = 100;
export const MAX_CUSTOM_EVENT_TYPE_LENGTH = 150;
